import { registerBlockType } from "@wordpress/blocks";
import config, { type BlockAttributes } from "./block.json";
import "../slider/swiper";
import NewsletterEditor from "./newsletterEditor";
import { InnerBlocks } from "@wordpress/block-editor";

registerBlockType<BlockAttributes>(config.name, {
  ...config,

  edit: NewsletterEditor,
  save(props) {
    return (
      <>
        <section className="newsletter position-relative alignfull">
          <img
            className="position-absolute"
            src={props.attributes.imageUrl}
            alt={props.attributes.imageAlt}
          />
          <div className="container h-100">
            <div className="row align-items-center">
              <div className="col-xl-6">
                <InnerBlocks.Content />
              </div>
              <div className="col-xl-6 d-flex flex-column gap-2 justify-content-center">
                [contact-form-7 id="60924bf" title="Newsletter"]
              </div>
            </div>
          </div>
        </section>
      </>
    );
  },
});
